
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  Col,
  Flex,
  List,
  Row,
  Tag,
  Typography,
  Popover,
  Tabs,
} from "antd";
import Title from "antd/es/typography/Title";
import {
  CustomersIcon,
  DecrementalArrowIcon,
  IncrementalArrowIcon,
  StarIcon,
} from "../../../../../assets/svg";
import { GetCardLayout } from "../../../../common/getCardLayout";
import ReactApexChart from "react-apexcharts";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import styles from "./SuperAdminDashboard.module.scss";
import mapsData from "../../../../../constants/maps/data.json";
import {
  getSuperAdminDashboardIndexAction,
  getSuperAdminDashboardOrderMetricsAction,
  getSuperAdminDashboardSalesMetricsAction,
} from "../../../../../redux/services/super-admin-dashboard/superAdminDashboardServices";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../../../../../constants/colors";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";

const yearArr = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
]

const SuperAdminDashboard = () => {
  const [, setLoadingComponent] = useState(false);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  /* table dependencies */
  const {
    superAdminDashboardIndex,
    superAdminDashboardSalesMetrics,
    superAdminDashboardOrderMetrics,
  } = useSelector((state) => state.superAdminDashboard);
  const [totalSalesByAppointmentTypeData, setTotalSalesByAppointmentTypeData] =
    useState({});
  const [barChartOrderProfitMetricsData, setBarChartOrderProfitMetricsData] =
    useState({
      series: [],
      options: {
        chart: {
          type: "line",
          height: 440,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
          fontSize: "16px",
          fontFamily: "Poppins",
          markers: {
            radius: 12,
          },
          itemMargin: {
            horizontal: 20,
            vertical: 0,
          },
        },
        xaxis: {
          categories: yearArr,
          labels: {
            style: {
              colors: [...Array(12)].map(() => colors.slateBlue),
              fontSize: "16px",
              fontFamily: "Poppins",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: [...Array(12)].map(() => colors.slateBlue),
              fontSize: "16px",
              fontFamily: "Poppins",
            },
          },
        },
        colors: [colors.indigo, colors.DarkMint, colors.crimson],
      },
    });
  const [
    donutChartTotalSalesByAppointmentTypeData,
    setDonutChartTotalSalesByAppointmentTypeData,
  ] = useState({
    options: {
      labels: [],
      
      colors: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                fontSize: "14px",
                fontWeight: 500,
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "14px",
        fontFamily: "Poppins",
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0,
        },
      },
    },
    series: [],
  });
  const [
    totalOrdersByAppointmentTypeData,
    setTotalOrdersByAppointmentTypeData,
  ] = useState({});
  const [
    donutChartTotalOrdersByAppointmentTypeData,
    setDonutChartTotalOrdersByAppointmentTypeData,
  ] = useState({
    options: {
      labels: [],
      colors: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                fontSize: "14px",
                fontWeight: 500,
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "14px",
        fontFamily: "Poppins",
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0,
        },
      },
    },
    series: [],
  });
  const [topServiceProviders, setTopServiceProviders] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [ordersHandledByServiceProviders, setOrdersHandledByServiceProviders] =
    useState([]);
  const [orderEarningsData, setOrderEarningsData] = useState({});
  const [donutChartOrderMetricsData, setDonutChartOrderMetricsData] = useState({
    options: {
      labels: [],
      colors: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                showAlways:false,
                fontSize: "14px",
                fontWeight: 500,
                formatter: function(w){
                    console.log(w, 'w')
                    let result = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    return result.toFixed(2) * 1
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "bottom",
        fontSize: "14px",
        fontFamily: "Poppins",
        markers: {
          radius: 12,
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0,
        },
      },
    },
    series: [],
  });
  const [donutChartSeries, setDonutChartSeries] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("2");
  /* table dependencies */

  useEffect(() => {
    if (
      totalSalesByAppointmentTypeData &&
      Object.entries(totalSalesByAppointmentTypeData)?.length !== 0 &&
      totalSalesByAppointmentTypeData?.totalSalesByAppointmentTypeDataArr &&
      totalSalesByAppointmentTypeData?.totalSalesByAppointmentTypeSalesArr
    ) {
      setDonutChartTotalSalesByAppointmentTypeData((prevValue) => {
        return {
          options: {
            ...prevValue.options,
            labels:
              totalSalesByAppointmentTypeData?.totalSalesByAppointmentTypeDataArr,
            colors: [colors.DarkMint, colors.indigo],
          },
          series:
            totalSalesByAppointmentTypeData?.totalSalesByAppointmentTypeSalesArr,
        };
      });
    }
  }, [totalSalesByAppointmentTypeData]);

  useEffect(() => {
    if (
      totalOrdersByAppointmentTypeData &&
      Object.entries(totalOrdersByAppointmentTypeData)?.length !== 0 &&
      totalOrdersByAppointmentTypeData?.totalOrdersByAppointmentTypeDataArr &&
      totalOrdersByAppointmentTypeData?.totalOrdersByAppointmentTypeSalesArr
    ) {
      setDonutChartTotalOrdersByAppointmentTypeData((prevValue) => {
        return {
          options: {
            ...prevValue.options,
            labels:
              totalOrdersByAppointmentTypeData?.totalOrdersByAppointmentTypeDataArr,
            colors: [colors.DarkMint, colors.indigo],
          },
          series:
            totalOrdersByAppointmentTypeData?.totalOrdersByAppointmentTypeSalesArr,
        };
      });
    }
  }, [totalOrdersByAppointmentTypeData]);

  useEffect(() => {
    if (
      orderEarningsData &&
      Object.entries(orderEarningsData)?.length !== 0
    ) {
      setBarChartOrderProfitMetricsData((prevValue) => {
        return {
          series: orderEarningsData,
          options: {
            ...prevValue.options,
          },
        };
      });
    }
  }, [orderEarningsData]);

  useEffect(() => {
    if (
      donutChartSeries &&
      donutChartSeries?.length !== 0
      
    ) {
      setDonutChartOrderMetricsData((prevValue) => {
        return {
          options: {
            ...prevValue.options,
            labels: ["Customers", "Service Providers"],
            colors: [colors.teal, colors.DarkMint],
          },
          series: donutChartSeries?.find((element)=>element.key === activeTabKey)?.series || [],
        };
      });
    }
  }, [donutChartSeries, activeTabKey]);

  const handleGetTableData = () => {
    dispatch(getSuperAdminDashboardIndexAction(setLoadingComponent)).then((apiRes)=>{
      const tempDonutCharArr = [];
      const dailyCountObj = {
        key: "1",
        label:"Daily",
        series:[apiRes?.customer_count?.today, apiRes?.organization_count?.today]
      }
      const weeklyCountObj = {
        key: "2",
        label:"Weekly",
        series:[apiRes?.customer_count?.last_7days, apiRes?.organization_count?.last_7days]
      }
      const monthlyCountObj = {
        key: "3",
        label:"Monthly",
        series:[apiRes?.customer_count?.this_month, apiRes?.organization_count?.this_month]
      }
      tempDonutCharArr.push(dailyCountObj);
      tempDonutCharArr.push(weeklyCountObj);
      tempDonutCharArr.push(monthlyCountObj);
      setDonutChartSeries(tempDonutCharArr)
    })

    dispatch(
      getSuperAdminDashboardSalesMetricsAction(setLoadingComponent)
    ).then((apiRes) => {
      const appointmentModes = {
        IN_PERSON: "In person",
        VIDEO_CALL: "Video call",
      };
      const totalSalesByAppointmentTypeDataArr =
        apiRes?.sales_by_appointment_mode
          ?.filter((elem) => !["NONE", "CHAT"].includes(elem._id))
          ?.map((element) => {
            return appointmentModes[element?._id];
          });
      const totalSalesByAppointmentTypeSalesArr =
        apiRes?.sales_by_appointment_mode
          ?.filter((elem) => !["NONE", "CHAT"].includes(elem._id))
          ?.map((element) => Math.round(element?.count) || 0)

      setTotalSalesByAppointmentTypeData({
        totalSalesByAppointmentTypeDataArr,
        totalSalesByAppointmentTypeSalesArr,
      });

      const totalOrdersByAppointmentTypeDataArr =
        apiRes?.orders_by_appointment_mode
          ?.filter((elem) => !["NONE", "CHAT"].includes(elem._id))
          .map((element) => {
            return appointmentModes[element?._id];
          });
      const totalOrdersByAppointmentTypeSalesArr =
        apiRes?.orders_by_appointment_mode
          ?.filter((elem) => !["NONE", "CHAT"].includes(elem._id))
          .map((element) => {
            return Math.round(element?.count) || 0
          });

      setTotalOrdersByAppointmentTypeData({
        totalOrdersByAppointmentTypeDataArr,
        totalOrdersByAppointmentTypeSalesArr,
      });

      setTopServiceProviders(apiRes?.top_n_organization);

      setTopCustomers(apiRes?.top_n_customer);

      setOrdersHandledByServiceProviders(apiRes?.order_handled_by_organization);
    });

    dispatch(
      getSuperAdminDashboardOrderMetricsAction(setLoadingComponent)
    ).then((apiRes) => {

      const tempOrderEarningsData = apiRes?.month_wise_count?.reduce((accumulator, element)=>{
        Object.keys(element).forEach((key)=>{
          let tempObj = {};
          let tempDataArr = Array(yearArr.length).fill(0);
          element[key]?.forEach((elem)=>tempDataArr[elem.month - 1] = elem.orders)
          tempObj["name"] = key.substring(0,1).toUpperCase() + key.slice(1);
          tempObj["data"] = tempDataArr;
          accumulator.push(tempObj)
        })
        return accumulator
      },[]);

      setOrderEarningsData(tempOrderEarningsData?.filter((element)=>!["Pending"].includes(element?.name)));
    });
  };

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Cards component - Section 1 */
  const CardComponent = () => {
    const dashoardIndexMetrics = {
      Customer_count: {
        icon: <CustomersIcon fillColor={colors.teal} />,
        backgroundColor: colors.teal,
        title: t("superAdminDashBoard.regCustomers"),
      },
      Organization_count: {
        icon: <CustomersIcon fillColor={colors.crimson} />,
        backgroundColor: colors.lightCoral,
        title: t("superAdminDashBoard.regService"),
      },
    };

    return (
      <>
        {superAdminDashboardIndex
          ?.filter((element) => element.key !== "Last_login_users")
          .map((item, index) => (
            <Col xs={24} sm={12} md={8} lg={8} key={index}>
              <Card
                hoverable
                style={{
                  backgroundColor:
                    dashoardIndexMetrics[item?.key]?.backgroundColor,
                  borderRadius: "20px",
                  height: "130px",
                }}
              >
                <Row gutter={16}>
                  <Col span={6}>{dashoardIndexMetrics[item?.key]?.icon}</Col>
                  <Col span={18}>
                    <Flex vertical gap="0.2rem">
                      <Typography.Paragraph
                        level={4}
                        style={{ margin: 0, color: colors.white }}
                      >
                        {" "}
                        {dashoardIndexMetrics[item?.key]?.title}
                      </Typography.Paragraph>
                      <Title
                        level={3}
                        style={{ margin: 0, color: colors.white }}
                      >
                        {item?.value?.total}
                      </Title>
                      <Flex
                        align="center"
                        gap="0.5rem"
                        style={{
                          background: colors.white,
                          width: "fit-content",
                          borderRadius: "0.2rem",
                          padding: "0.1rem 0.5rem",
                        }}
                      >
                        {item?.value?.this_month_last_month?.split(" ")[1] ===
                        "up" ? (
                          <IncrementalArrowIcon />
                        ) : (
                          <DecrementalArrowIcon />
                        )}
                        <Title level={5} style={{ margin: 0 }}>
                          <span
                            style={{
                              color:
                                item?.value?.this_month_last_month?.split(
                                  " "
                                )[1] === "up"
                                  ? colors.green
                                  : colors.darkMaroon,
                            }}
                          >
                            {item?.value?.this_month_last_month?.split(" ")[0]}
                          </span>{" "}
                          {t("superAdminDashBoard.thanLastMonth")}
                        </Title>
                      </Flex>
                    </Flex>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        <Col xs={24} sm={12} md={8} lg={8}>
          <Card
            hoverable
            style={{
              backgroundColor: colors.mango,
              borderRadius: "20px",
              height: "130px",
            }}
          >
            <Row gutter={16}>
              <Col span={6}>
                <CustomersIcon fillColor={colors.mango} />
              </Col>
              <Col span={18}>
                <Flex vertical gap="0.2rem">
                  <Typography.Paragraph
                    level={4}
                    style={{ margin: 0, color: colors.white }}
                  >
                    {" "}
                    {t("superAdminDashBoard.orderMonthlyProfit")}
                  </Typography.Paragraph>
                  <Title level={3} style={{ margin: 0, color: colors.white }}>
                    {superAdminDashboardSalesMetrics?.order_profit?.this_month}
                  </Title>
                  <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.white,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {superAdminDashboardSalesMetrics?.order_profit?.this_month_last_month?.split(
                      " "
                    )[1] === "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{ margin: 0 }}>
                      <span
                        style={{
                          color:
                            superAdminDashboardSalesMetrics?.order_profit?.this_month_last_month?.split(
                              " "
                            )[1] === "up"
                              ? colors.green
                              : colors.darkMaroon,
                        }}
                      >
                        {
                          superAdminDashboardSalesMetrics?.order_profit?.this_month_last_month?.split(
                            " "
                          )[0]
                        }
                      </span>{" "}
                      {t("superAdminDashBoard.thanLastMonth")}
                    </Title>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <Card
            hoverable
            style={{
              backgroundColor: colors.limeGreen,
              borderRadius: "20px",
              height: "130px",
            }}
          >
            <Row gutter={16}>
              <Col span={6}>
                <CustomersIcon fillColor={colors.limeGreen} />
              </Col>
              <Col span={18}>
                <Flex vertical gap="0.2rem">
                  <Typography.Paragraph
                    level={4}
                    style={{ margin: 0, color: colors.white }}
                  >
                    {" "}
                    {t("superAdminDashBoard.orderSales")}
                  </Typography.Paragraph>
                  <Title level={3} style={{ margin: 0, color: colors.white }}>
                    {superAdminDashboardSalesMetrics?.order_sales?.this_month}
                  </Title>
                  <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.white,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {superAdminDashboardSalesMetrics?.order_sales?.this_month_last_month?.split(
                      " "
                    )[1] === "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{ margin: 0 }}>
                      <span
                        style={{
                          color:
                            superAdminDashboardSalesMetrics?.order_sales?.this_month_last_month?.split(
                              " "
                            )[1] === "up"
                              ? colors.green
                              : colors.darkMaroon,
                        }}
                      >
                        {
                          superAdminDashboardSalesMetrics?.order_sales?.this_month_last_month?.split(
                            " "
                          )[0]
                        }
                      </span>{" "}
                      {t("superAdminDashBoard.thanLastMonth")}
                    </Title>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <Card
            hoverable
            style={{
              backgroundColor: colors.magenta,
              borderRadius: "20px",
              height: "130px",
            }}
          >
            <Row gutter={16}>
              <Col span={6}>
                <CustomersIcon fillColor={colors.magenta} />
              </Col>
              <Col span={18}>
                <Flex vertical gap="0.2rem">
                  <Typography.Paragraph
                    level={4}
                    style={{ margin: 0, color: colors.white }}
                  >
                    {" "}
                    {t("superAdminDashBoard.totalOrdersToday")}
                  </Typography.Paragraph>
                  <Title level={3} style={{ margin: 0, color: colors.white }}>
                    {superAdminDashboardSalesMetrics?.order_count?.today}
                  </Title>
                  <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.white,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                      " "
                    )[1] === "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{ margin: 0 }}>
                      <span
                        style={{
                          color:
                            superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                              " "
                            )[1] === "up"
                              ? colors.green
                              : colors.darkMaroon,
                        }}
                      >
                        {
                          superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                            " "
                          )[0]
                        }
                      </span>{" "}
                      {t("superAdminDashBoard.thanLastMonth")}
                    </Title>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <Card
            hoverable
            style={{
              backgroundColor: colors.orange,
              borderRadius: "20px",
              height: "130px",
            }}
          >
            <Row gutter={16}>
              <Col span={6}>
                <CustomersIcon fillColor={colors.orange} />
              </Col>
              <Col span={18}>
                <Flex vertical gap="0.2rem">
                  <Typography.Paragraph
                    level={4}
                    style={{ margin: 0, color: colors.white }}
                  >
                    {" "}
                    {t("superAdminDashBoard.totalOrdersMonth")}
                  </Typography.Paragraph>
                  <Title level={3} style={{ margin: 0, color: colors.white }}>
                    {superAdminDashboardSalesMetrics?.order_count?.this_month}
                  </Title>
                  <Flex
                    align="center"
                    gap="0.5rem"
                    style={{
                      background: colors.white,
                      width: "fit-content",
                      borderRadius: "0.2rem",
                      padding: "0.1rem 0.5rem",
                    }}
                  >
                    {superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                      " "
                    )[1] === "up" ? (
                      <IncrementalArrowIcon />
                    ) : (
                      <DecrementalArrowIcon />
                    )}
                    <Title level={5} style={{ margin: 0 }}>
                      <span
                        style={{
                          color:
                            superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                              " "
                            )[1] === "up"
                              ? colors.green
                              : colors.darkMaroon,
                        }}
                      >
                        {
                          superAdminDashboardSalesMetrics?.order_count?.this_month_last_month?.split(
                            " "
                          )[0]
                        }
                      </span>{" "}
                      {t("superAdminDashBoard.thanLastMonth")}
                    </Title>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>
      </>
    );
  };
  /* Cards component - Section 1 */


  /* Consultation Status And NewRegistrations Component - Section 2 */
  const ConsultationStatusAndNewRegistrationsComponent = () => {
    const tabItems = [
      {
        key: "1",
        label: t("superAdminDashBoard.daily"),
        children: (
          <ReactApexChart
            type="donut"
            height={440}
            options={donutChartOrderMetricsData?.options}
            series={donutChartOrderMetricsData?.series}
          />
        ),
      },
      {
        key: "2",
        label: t("superAdminDashBoard.weekly"),
        children: (
          <ReactApexChart
            type="donut"
            height={440}
            options={donutChartOrderMetricsData?.options}
            series={donutChartOrderMetricsData?.series}
          />
        ),
      },
      {
        key: "3",
        label: t("superAdminDashBoard.monthly"),
        children: (
          <ReactApexChart
            type="donut"
            height={440}
            options={donutChartOrderMetricsData?.options}
            series={donutChartOrderMetricsData?.series}
          />
        ),
      },
    ];

    return (
      <>
        <Col span={16}>
          <GetCardLayout style={{ height: "530px" }}>
            <Flex gap="1rem" vertical>
              <Typography.Title level={2}>{t("superAdminDashBoard.consultationStatus")}</Typography.Title>

              <ReactApexChart
                type="bar"
                height={440}
                options={barChartOrderProfitMetricsData?.options}
                series={barChartOrderProfitMetricsData?.series}
              />
            </Flex>
          </GetCardLayout>
        </Col>
        
        <Col span={8}>
          <GetCardLayout style={{ height: "530px" }}>
            <Flex gap="1rem" vertical>
              <Typography.Title level={2}>{t("superAdminDashBoard.newRegistrations")}</Typography.Title>
              <Flex gap="1rem" align="center" justify="center">
                <Tabs
                  defaultActiveKey={activeTabKey}
                  type="card"
                  items={tabItems}
                  centered
                  onChange={(key)=>setActiveTabKey(key)}
                />
              </Flex>
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Consultation Status And NewRegistrations Component - Section 2 */

  /* Total Sales - Section 3 */
  const TotalSalesComponent = () => {
    function getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    const updatedArray = superAdminDashboardSalesMetrics?.top_n_country?.map(
      (s) => ({ ...s, randomColor: getRandomColor() })
    );
    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "100%" }}>
            <Flex vertical gap="3rem">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.totalSalesAppt")}
              </Typography.Title>
              <ReactApexChart
                type="donut"
                height={440}
                options={donutChartTotalSalesByAppointmentTypeData?.options}
                series={donutChartTotalSalesByAppointmentTypeData?.series}
                width={"100%"}
              />
            </Flex>
          </GetCardLayout>
        </Col>

        <Col span={16} className={styles.mapsContainer}>
          <GetCardLayout style={{ height: "100%" }}>
            <Typography.Title level={2}>
              {t("superAdminDashBoard.totalSalesCountry")}
            </Typography.Title>
            <ComposableMap>
              <Geographies geography={mapsData}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography key={geo.rsmKey} geography={geo} />
                  ))
                }
              </Geographies>
              {updatedArray?.map(
                ({
                  country_name,
                  orders,
                  revenue,
                  latitude,
                  longitude,
                  randomColor,
                }) => {
                  return (
                    <>
                      <Popover
                        content={
                          <Flex gap="1rem" align="center" justify="center">
                            <Title type="secondary" level={3}>
                              {country_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.darkSearGreen,
                                color: colors.limeGreen,
                              }}
                            >
                              {revenue}
                            </Tag>
                          </Flex>
                        }
                      >
                        <Marker
                          key={country_name}
                          coordinates={[Number(longitude), Number(latitude)]}
                        >
                          <circle
                            r={10}
                            fill={randomColor}
                            stroke="#FFF"
                            strokeWidth={2}
                          />
                        </Marker>
                      </Popover>
                    </>
                  );
                }
              )}
            </ComposableMap>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Total Sales - Section 3 */

  /* Total Orders and Service providers - Section 4 */
  const TotalOrdersAndServiceProvidersComponent = () => {
    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            {/* <Flex gap="2rem" vertical> */}
            <Typography.Title level={2}>
              {t("superAdminDashBoard.totalOrdersAppt")}
            </Typography.Title>
            <div style={{ maxWidth: "100% !important" }}>
              <ReactApexChart
                type="donut"
                height={440}
                options={donutChartTotalOrdersByAppointmentTypeData?.options}
                series={donutChartTotalOrdersByAppointmentTypeData?.series}
                width={"100%"}
              />
            </div>
            {/* </Flex> */}
          </GetCardLayout>
        </Col>

        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.requestServices")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={superAdminDashboardSalesMetrics?.top_n_service}
                  renderItem={(item) => (
                    <List.Item key={item?.name}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        avatar={
                          <Avatar
                            size="large"
                            src={
                              item?.images?.[0]?.url
                            }
                            icon={<UserOutlined />}
                          />
                        }
                        title={
                          <Title type="secondary" level={3}>
                            {item.service_name}
                          </Title>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>

        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.requestProviders")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={
                    superAdminDashboardSalesMetrics?.order_handled_by_organization
                  }
                  renderItem={(item) => (
                    <List.Item key={item.email}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        avatar={
                          <Avatar size="large" src={item.organization_logo} icon={<UserOutlined />}/>
                        }
                        title={
                          <Title type="secondary" level={3}>
                            {item.organization_name}
                          </Title>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Total Orders and Service providers - Section 4 */

  /* Top Service Providers and Customers - Section 5 */
  const TopServiceProvidersCustomers = () => {
    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.ordersHandled")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={ordersHandledByServiceProviders}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {item.organization_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.slatePurple,
                                color: colors.indigo,
                              }}
                            >{`${item.orders} Orders`}</Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>

        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.serviceSales")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={topServiceProviders}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {item.organization_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.darkSearGreen,
                                color: colors.limeGreen,
                              }}
                            >
                              {item.sales}
                            </Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>

        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.revenue")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={topCustomers}
                  renderItem={(item) => (
                    <List.Item key={item._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        title={
                          <Flex justify="space-between">
                            <Title type="secondary" level={3}>
                              {item.customer_name}
                            </Title>
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.slatePurple,
                                color: colors.indigo,
                              }}
                            >
                              {item.revenue}
                            </Tag>
                          </Flex>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Top Service Providers and Customers - Section 5 */

  /* Feedback and ratings - Section 6 */
  const FeedbackAndRatings = () => {
    return (
      <>
        <Col span={8}>
          <GetCardLayout style={{ height: "450px" }}>
            <Flex vertical gap="1rem" justify="space-around">
              <Typography.Title level={2}>
                {t("superAdminDashBoard.feedback")}
              </Typography.Title>
              <div
                style={{
                  height: 350,
                  overflow: "auto",
                }}
              >
                <List
                  dataSource={superAdminDashboardOrderMetrics?.review_top_10}
                  renderItem={(item) => (
                    <List.Item key={item?.user_id?._id}>
                      <List.Item.Meta
                        style={{ alignItems: "center" }}
                        avatar={
                          <Avatar
                            size="large"
                            src={item?.user_id?.profile_image}
                            icon={<UserOutlined />}
                          />
                        }
                        title={
                          <Title
                            type="secondary"
                            level={3}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {`${item?.user_id?.first_name} ${item?.user_id?.last_name}`}{" "}
                            <Tag
                              bordered={false}
                              style={{
                                background: colors.darkGoldenRod,
                                color: colors.pumpkin,
                              }}
                            >
                              <Flex
                                align="center"
                                justify="center"
                                gap="0.3rem"
                              >
                                <StarIcon fillColor={colors.pumpkin} />
                                {`${item.rating.toFixed(1)}`}
                              </Flex>
                            </Tag>
                          </Title>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </Flex>
          </GetCardLayout>
        </Col>
      </>
    );
  };
  /* Feedback and ratings - Section 6 */

  return (
    <>
      <div className={styles.dashboardMainContainer}>
        <Row gutter={[16, 16]}>
          <CardComponent />
          <ConsultationStatusAndNewRegistrationsComponent />
          <TotalSalesComponent />
          <TotalOrdersAndServiceProvidersComponent />
          <TopServiceProvidersCustomers />
          <FeedbackAndRatings />
        </Row>
      </div>
    </>
  );
};

export default SuperAdminDashboard;
